import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import App from "./containers/App";
import store, { history } from "./redux/store";
import { ErrorBoundary } from "react-error-boundary";
import RedirectFallbackErrorPage from "routes/ErrorPage/RedirectFallbackErrorPage";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./styles/index.scss";
import { useCallback } from "react";
import { LoggingAPI } from "services/logging-server";
import { DeviceUtil } from "utils/device-util";

const MoneyConnect = () => {
  const onError = useCallback(async (error, errorInfo) => {
    if (error) {
      try {
        const params = new URLSearchParams(window.location?.search);
        const authToken = params.get("code");
        await LoggingAPI.error({
          authToken,
          message: JSON.stringify({
            error: {
              message: error.message,
              originError: error,
              errorInfo,
            },
            deviceInfo: DeviceUtil.getDeviceInfo(),
          }),
        });
      } catch (_) {}
    }
  }, []);

  return (
    <ErrorBoundary FallbackComponent={RedirectFallbackErrorPage} onError={onError}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>
  );
};

export default MoneyConnect;
